// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// WARNING - Values under "firebase" and value of "googleApiKey" needs to be replaced from your own accounts
// If left as is, it firbase and google map related functionality will not work on LIVE instance.
export const environment = {
  prismaApiUrl: 'https://szsapi.go4flow.de',
  prismaApiUrlProd: 'https://SV-PAT-MPDB01.med.tu-dresden.de/szs-pro/public',
  //prismaApiUrl: 'https://szsapi.go4flow.de',
  //https://SV-PAT-MPDB01.med.tu-dresden.de/szs-pro/public
  //http://localhost:8000
  production: false,
  firebase: {
    apiKey: 'AIzaSyCSG-EGU2RLITgpjf_ogf1w47edC_DXlWc',
    authDomain: 'evolvision-rnd.firebaseap  p.com',
    databaseURL: 'https://evolvision-rnd.firebaseio.com',
    projectId: 'evolvision-rnd',
    storageBucket: 'evolvision-rnd.appspot.com',
    messagingSenderId: '890895206035',
    appId: '1:890895206035:web:a6d0e1574d59ffe40bef66'
  },
  googleApiKey: 'AIzaSyAIIYOxA7qeetFz6TuR1Qewc0Rrjhzx7ZU',
  whoIcdApi: {
    clientId: '523b8289-6ce8-4df4-aa2a-e0a113fbb708_3d1efb41-73f1-47af-b3a3-31e647302b78',
    clientSecret: 'hX3iZempMjRkLTFnmwm8Koz7TamCNnjEG8Qd2DE7YEY='
  },
  n8nApiKey: 'hX3iZempMjRkLTFnmwm8Koz7TamCNnjEG8Qd2DE7YEY'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
